import Directions from '@mui/icons-material/Directions';
import Map from './Map';
import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import StreetView from '@mui/icons-material/Streetview';

const MenuLocationMap = (props) => {
  const { loadingLocation, locationDetails } = props;

  if (loadingLocation || locationDetails.id === undefined) {
    return <div className="location-map">
      <div className="location-map__map">
        <Skeleton variant="rectangular" width="100%" height={280} sx={{ bgcolor: 'grey.600' }}/>
      </div><address className="location-map__address">
        <div className="address">
          <Skeleton width="30%" height={30} />
          <Skeleton width="21%" height={25} />
        </div><div className="address-buttons">
          <div className="address-buttons--directions">
            <Skeleton width="26%" height={30} style={{float: 'right'}} />

          </div>
          <div className="address-buttons--streetview">
            <Skeleton width="18%" height={25} style={{float: 'right'}} />
          </div>
        </div>
      </address>
    </div>
  } else {
    const { latitude, longitude, googlePlaceId, formalName, address, streetViewUrl } = locationDetails;
    let directionsUrl = "https://maps.google.com?saddr=Current+Location&daddr=" + latitude + "," + longitude;

    return <div className="location-map">
      <div className="location-map__map">
        <Map
          formalName={formalName}
          googlePlaceId={googlePlaceId}
        />
      </div>

      <address className="location-map__address">
        <div className="address">
          <div className="address-street">{address.street}</div>
          <div className="address-info">{address.city}, {address.state} {address.zipCode}</div>
        </div>
        <div className="address-buttons">
          <div className="address-buttons--directions">
            <a href={directionsUrl} rel="noopener noreferrer" target="_blank"><Directions /> Get directions</a>
          </div>
          <div className="address-buttons--streetview">
            <a href={streetViewUrl} rel="noopener noreferrer" target="_blank"><StreetView /> Street view</a>
          </div>
        </div>
      </address>
    </div>;
  }
}

export default MenuLocationMap;